import { useNavigate } from 'react-router';
import axios from './axios';
import * as queries from './apolloQueries';
const accessToken = localStorage.getItem('diologAuthToken');
const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const nth = function (d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
const weekDaysName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const FormatDate = (unFormattedDate, type = null) => {
    var d = new Date(unFormattedDate),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        monthName = '' + monthNames[d.getMonth()],
        year = d.getFullYear(),
        hours = d.getHours(),
        weekDay = d.getDay(),
        minutes = d.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    let hoursNew = hours;
    hoursNew = hoursNew % 12;
    hoursNew = hoursNew ? hoursNew : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var weekDayName = weekDaysName[weekDay];
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (type === 'announcements') {
        return [day, monthName, year].join(' ');
    } else if (type === 'd/m/Y') {
        return [day, month, year].join('/');
    } else if (type === 'Y/m/d') {
        return [year, month, day].join('/');
    } else if (type === 'h:i:s') {
        return [hours, minutes, '00'].join(':');
    } else if (type === 'history_detail') {
        return [day, month, year].join('/') + ' ' + hoursNew + ':' + minutes + ' ' + ampm;
    } else if (type === 'questionsDetails') {
        return `${day} ${monthName} ${year} ${hoursNew.toString().padStart(2, '0')}:${minutes} ${ampm.toUpperCase()}`;
    } else if (type === 'calendar') {
        return [monthName, year].join(', ');
    } else if (type === 'calendar-form-date') {
        return [day, month, year].join('/');
    } else if (type === 'calendar-form-hour') {
        return [hoursNew.toString().padStart(2, '0'), minutes.toString().padStart(2, '0')].join(':');
    } else if (type === 'calendar-list-date') {
        return day + ' ' + monthName + ', ' + weekDayName;
    } else if (type === 'event_detail_date') {
        return `${weekDayName}, ${day} ${monthName}`;
    } else if (type === 'event-time') {
        return hoursNew + ':' + minutes + ' ' + ampm;
    } else if (type === 'allData') {
        return [parseInt(year), parseInt(month), parseInt(day), parseInt(hours), parseInt(minutes)];
    } else {
        return [day, month, year].join('-');
    }
};
export const UploadFile = async (selectedFile, query, isBlob, signal) => {
    if (selectedFile) {
        let o = {
            query: query,
            variables: {
                file: null
            }
        };
        let map = {
            0: ['variables.file']
        };
        let fd = new FormData();
        if (!isBlob) {
            fd.append('operations', JSON.stringify(o));
            fd.append('map', JSON.stringify(map));
            fd.append(0, selectedFile);
        } else {
            fd.append('operations', JSON.stringify(o));
            fd.append('map', JSON.stringify(map));
            fd.append(0, selectedFile, `Investor-sentiment${new Date().getTime()}.png`);
        }
        const signObj = signal ? { signal: signal } : {};
        const result = await axios({
            method: 'POST',
            data: fd,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: accessToken
            },
            ...signObj
        })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data) {
                        if (response.data.data) {
                            return response.data.data;
                        } else {
                            console.log(response);
                        }
                    }
                } else {
                    console.log(response);
                }
            })
            .catch(function (response) {
                throw response;
            });
        return result;
    }
};

export const uploadFileChunkGraphQL = async (fileChunk, chunkIndex, totalChunks, fileName, signal) => {
    try {
        const graphqlQuery = `
        mutation UploadChunk($chunkIndex: Int!, $file: Upload!, $fileName: String!, $totalChunks: Int!) {
            uploadChunk(chunkIndex: $chunkIndex, file: $file, fileName: $fileName, totalChunks: $totalChunks) {
              attachmentDuration
              key
              thumbnailKey
            }
          }
      `;
        const formData = new FormData();
        formData.append(
            'operations',
            JSON.stringify({
                query: graphqlQuery,
                variables: {
                    file: null, // Placeholder for file upload
                    chunkIndex: chunkIndex,
                    totalChunks: totalChunks,
                    fileName
                }
            })
        );
        formData.append(
            'map',
            JSON.stringify({
                0: ['variables.file']
            })
        );
        formData.append('0', new Blob([fileChunk]));
        const response = await axios.post('', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            signal // Pass the signal to the request
        });

        return response.data;
    } catch (error) {
        console.error('Error uploading file chunk:', error);
        throw error;
    }
};

export const LogOut = () => {
    const navigate = useNavigate();
    localStorage.removeItem('diologAuthToken');
    localStorage.removeItem('diologUserData');
    localStorage.removeItem('diologRefToken');
    navigate('/');
    location.reload();
};
export const getSignedUrlFromKey = async (key) => {
    const submitData = { query: queries.getImage, variables: { key: key } };
    let returnVal = null;
    return axios({
        method: 'POST',
        data: submitData
    })
        .then(function (response) {
            if (response.status === 200) {
                if (response.data.data) {
                    if (response.data.data.getSignedUrlFromKey) {
                        returnVal = response.data.data.getSignedUrlFromKey.signedUrl;
                    }
                }
            }
            return returnVal;
        })
        .catch(function (response) {
            console.log(response, 'failed loading user data');
            return null;
        });
};
export const checkUploadedFile = (file, type = null, size = 125) => {
    let uploadedFile = file;
    if (uploadedFile) {
        if (uploadedFile.size / 1024 >= size) {
            return {
                toastObject: true,
                status: true,
                message: 'Maximum file size of 125kb exceeded',
                variant: 'warning'
            };
        } else if (
            uploadedFile.type !== 'image/jpeg' &&
            uploadedFile.type !== 'image/png' &&
            uploadedFile.type !== 'application/pdf' &&
            uploadedFile !== 'video/mp4' &&
            uploadedFile !== 'audio/mpeg'
        ) {
            return {
                toastObject: true,
                status: true,
                message: 'Unsupported file format. Please upload .jpeg/.jpg/.png file.',
                variant: 'warning'
            };
        } else {
            return {
                toastObject: false
            };
        }
    }
};
export function timeDiffCalc(dateFuture, dateNow) {
    let diffInMilliSeconds = Math.abs(new Date(dateFuture) - new Date(dateNow)) / 1000;
    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    let difference = [];
    if (days > 0) {
        difference['days'] = days;
    }

    difference['hours'] = hours;

    difference['minutes'] = minutes;

    return difference;
}
export function updateCalendarDate(data) {
    let date2 = new Date(data);
    let y = date2.getFullYear();
    let m = date2.getMonth();
    let lastDate = new Date(y, m + 1, 0);
    return lastDate;
}
